import req from '@/utils/request';

const salaryApi = '/doctor/salary';

export const doctorRulePage = (params) => {
  return req.post(`/salary/doctor-rule/page`, params);
}

export const doctorRuleSave = (params) => {
  return req.post(`/salary/doctor-rule`, params);
}
export const doctorRuleUpdate = (params) => {
  return req.put(`/salary/doctor-rule`, params);
}

export const getDoctorRule = (params) => {
  return req.get(`/salary/doctor-rule`, params);
}

export const deleteDoctorRuleById = (id) => {
  return req.delete(`/salary/doctor-rule/${id}`);
}

export const getDoctorRuleImportTemplate = (customConfig) => {
  return req.downloadGet(`/salary/doctor-rule/import/template`, {}, customConfig, 'application/vnd.ms-excel');
}

export const importDoctorRule = (params) => {
  return req.post(`/salary/doctor-rule/import`, params, '/api', 'multipart/form-data');
}

export const salaryCommissionSave = (params) => {
  return req.post(`/salary/special-retail-commission`, params);
}

export const salaryCommissionPage = (params) => {
  return req.post(`/salary/special-retail-commission/page`, params);
}

export const salaryCommissionDelete = (params) => {
  return req.delete(`/salary/special-retail-commission`, params);
}

export const salaryCommissionUpdate = (params) => {
  return req.put(`/salary/special-retail-commission`, params);
}

export const salaryCommissionDetail = (params) => {
  return req.get(`/salary/special-retail-commission/detail`, params);
}

export const salaryMeituanPhysioCommissionPage = (params) => {
  return req.post(`/salary/meituan-physio-commission/page`, params);
}

export const getRegisterFee = (params) => {
  return req.get(`/salary/meituan-physio-commission/order/price`, params);
}

export const saveRegisterFee = (registerFee) => {
  return req.post(`/salary/meituan-physio-commission/order/price?orderPrice=${registerFee}`);
}

export const salaryMeituanPhysioCommissionDetail = (params) => {
  return req.get(`/salary/meituan-physio-commission/detail`, params);
}

export const salaryMeituanPhysioCommissionSave = (params) => {
  return req.post(`/salary/meituan-physio-commission/save`, params);
}

export const salaryBillPage = (params) => {
  return req.post(`/salary/bill/page`, params);
}

export const salaryBillGenerate = (salaryMonth) => {
  return req.post(`/salary/bill/regenerate?salaryMonth=${salaryMonth}`);
}

export const doctorSalaryBillPage = (params) => {
  return req.post(`/salary/detail/page`, params);
}
export const doctorSalaryBillDeptPage = (params) => {
  return req.post(`/salary/detail/dept-page`, params);
}

export const salaryDetailExport = (params,customConfig) => {
  return req.downloadGet(`/salary/detail/export`, params,customConfig, 'application/vnd.ms-excel');
}

export const salaryDetailDeptExport = (params,customConfig) => {
  return req.downloadGet(`/salary/detail/dept-export`, params,customConfig, 'application/vnd.ms-excel');
}

export const doctorRuleExport = (params,customConfig) => {
  return req.downloadGet(`/salary/doctor-rule/export`, params,customConfig, 'application/vnd.ms-excel');
}




